import { render, staticRenderFns } from "./JCodeEditor.vue?vue&type=template&id=1c151e52&"
import script from "./JCodeEditor.vue?vue&type=script&lang=js&"
export * from "./JCodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./JCodeEditor.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports